module.exports = __webpack_public_path__ + "images/a7799621205a7e9d3e250473e2c5aade.jpg";